import { auth, functionsBaseUrl } from "../../firebase";
import { BankingDetailstype, RestaurantAPIServiceGetBankingDetailsRequestType, RestaurantAPIServiceGetBankingDetailsResponseType, RestaurantAPIServiceSetBankingDetailsRequestType, RestaurantAPIServiceSetBankingDetailsResponseType } from "../../models/bankingDetailsType";


export const RestaurantAPIService = {
  getBankingDetails: async (restaurantId: string): Promise<BankingDetailstype | undefined> => {
    if (!auth.currentUser) {
      return undefined;
    }

    const idToken: string = await auth.currentUser.getIdToken()
    const body: RestaurantAPIServiceGetBankingDetailsRequestType = {
      restaurantId
    }

    const response = await fetch(`${functionsBaseUrl}/getRestaurantBankingDetails`, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${idToken}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(body),
    });
    console.log(response)
    if (response.status === 200) {
      return ((await response.json()) as RestaurantAPIServiceGetBankingDetailsResponseType).bankingDetails;
    } 
    return undefined;
  },

  setBankingDetails: async (restaurantId: string, bankingDetails: BankingDetailstype): Promise<BankingDetailstype | undefined> => {
    if (!auth.currentUser) {
      return undefined;
    }
    const idToken: string = await auth.currentUser.getIdToken()
    const body: RestaurantAPIServiceSetBankingDetailsRequestType = {
      restaurantId,
      bankingDetails
    }

    const response = await fetch(`${functionsBaseUrl}/setRestaurantBankingDetails`, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${idToken}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(body),
    });
    console.log(response)
    if (response.status === 200) {
      return ((await response.json()) as RestaurantAPIServiceSetBankingDetailsResponseType).bankingDetails;
    }
    return undefined;
  }
};

